import React, { useState } from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { FiCheckSquare, FiBarChart2, FiZap ,FiAlertCircle } from "react-icons/fi";
import AvailabilityDp from "./Availabilitydp";
import CoolerImpurityDp from "./CoolerImpuritydp";
import ActivationDp from "./Activationdp";
import UnResolvedProductsDp from "./UnResolvedProductsDp";
import { getCurrentDate,getFirstDayOfMonth } from "Utils/dateUtils";
import { useDateFilter } from "Hooks/useDateFilter";
import { SCREEN_KEYS } from "constants/screenKeys";
import DateRangeFilter from "components/DateRangeFilter/DateRangeFilter";


function VarianceReport() {

   const { fromDate, toDate, setFromDate, setToDate } = useDateFilter(
      SCREEN_KEYS.VARAINCE_REPORT,
      { fromDate: getFirstDayOfMonth(), toDate: getCurrentDate() }
    );
  
    const handleFromDateChange = (value) => {
      setFromDate(value);
      if (value > toDate) setToDate(value);
    };
  
    const handleToDateChange = (value) => {
      if (value < fromDate) return;
      setToDate(value);
    };
  

   const tabStyle = {
    fontWeight: "semibold",
    fontSize: "md",
    py: 3,
    px: 6,
    borderRadius: "lg",
    color: "gray.600",
    display: "flex",
    gap: 2,
    alignItems: "center",
    _selected: { bg: "red.600", color: "white", boxShadow: "md" },
    _hover: { bg: "red.200", color: "red.700" },
  };
 

 

  return (
    <Box minH="100vh" bg="gray.50" pt={{ base: "10vh", md: "13vh" }} px={6}>
      {/* Page Header */}
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align={{ base: "flex-start", md: "center" }}
        mb={6}
      >
        <Box>
          <Heading size="lg" color="gray.800" mb={2}>
            Variance Reports
          </Heading>
          <Text color="gray.500">
            Monitor store availability, activation, and view SOVI &amp; RED score reports
          </Text>
        </Box>
      </Flex>

      {/* Main Tabs */}
      <Tabs variant="unstyled" isLazy>
        <TabList
          bg="red.100"
          p={2}
          borderRadius="lg"
          gap={2}
          display="inline-flex"
          mb={6}
        >
          <Tab {...tabStyle}>
            <FiCheckSquare size={18} /> Availability
          </Tab>
          <Tab {...tabStyle}>
            <FiZap size={18} /> Activation
          </Tab>
          <Tab {...tabStyle}>
            <FiBarChart2 size={18} /> Cooler Purity
          </Tab>
           <Tab {...tabStyle}><FiAlertCircle size={18} /> Unresolved Products</Tab>
        </TabList>

        <TabPanels>
          {/* ── Tab 1: Availability ── */}
          <TabPanel p={0}>
            <Flex
              direction={{ base: "column", md: "row" }}
              justify="space-between"
              align={{ base: "flex-start", md: "center" }}
              mb={6}
            >
              <Box>
                <Heading size="md" color="gray.700" mb={1}>
                  Availability
                </Heading>
                <Text color="gray.500" fontSize="sm">
                  Track store-level availability across date ranges
                </Text>
              </Box>
              <DateRangeFilter
                 fromDate={fromDate}
                 toDate={toDate}
                onFromDateChange={handleFromDateChange}
                onToDateChange={handleToDateChange}
                    />
            </Flex>
            <AvailabilityDp fromDate={fromDate} toDate={toDate}/>
          </TabPanel>

          {/* ── Tab 2: Activation ── */}
          <TabPanel p={0}>
            <Flex
              direction={{ base: "column", md: "row" }}
              justify="space-between"
              align={{ base: "flex-start", md: "center" }}
              mb={6}
            >
              <Box>
                <Heading size="md" color="gray.700" mb={1}>
                  Activation
                </Heading>
                <Text color="gray.500" fontSize="sm">
                  View store-level activation scores and product qualification counts
                </Text>
              </Box>
              <DateRangeFilter
                 fromDate={fromDate}
                 toDate={toDate}
                onFromDateChange={handleFromDateChange}
                onToDateChange={handleToDateChange}
              />
            </Flex>
            <ActivationDp fromDate={fromDate} toDate={toDate} />
          </TabPanel>

          {/* ── Tab 3: Cooler Purity ── */}
          <TabPanel p={0}>
            <Flex
              direction={{ base: "column", md: "row" }}
              justify="space-between"
              align={{ base: "flex-start", md: "center" }}
              mb={6}
            >
              <Box>
                <Heading size="md" color="gray.700" mb={1}>
                  SOVI &amp; RED Reports
                </Heading>
                <Text color="gray.500" fontSize="sm">
                  View RED scores and SOVI report by store
                </Text>
              </Box>
              <DateRangeFilter
                 fromDate={fromDate}
                 toDate={toDate}
                  onFromDateChange={handleFromDateChange}
                  onToDateChange={handleToDateChange}
              />
            </Flex>
            <CoolerImpurityDp fromDate={fromDate} toDate={toDate} />
          </TabPanel>

          {/*  Tab 4: Unresolved Products */}
          <TabPanel p={0}>
            <Flex direction={{ base: "column", md: "row" }} justify="space-between" align={{ base: "flex-start", md: "center" }} mb={6}>
              <Box>
                <Heading size="md" color="gray.700" mb={1}>Unresolved Products</Heading>
                <Text color="gray.500" fontSize="sm">Track products that remain unresolved across stores</Text>
              </Box>
              <DateRangeFilter
                 fromDate={fromDate}
                  toDate={toDate}
                  onFromDateChange={handleFromDateChange}
                  onToDateChange={handleToDateChange}
                      />
            </Flex>
            <UnResolvedProductsDp fromDate={fromDate} toDate={toDate} />
          </TabPanel>

        </TabPanels>
      </Tabs>
    </Box>
  );
}

export default VarianceReport;